import * as React from 'react'
import { observer } from 'mobx-react'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogFooter,
  DialogButton,
  DialogHeader,
  DialogDescription,
} from 'components/Dialog'
import { ConfirmViewModel } from './ConfirmViewModel'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  title?: string
  description?: React.ReactNode
  yesText?: string
  noText?: string
  danger?: boolean
  illustration?: React.ReactNode
  state: ConfirmViewModel
}

export default observer(function ConfirmDialog({
  title,
  yesText,
  noText,
  state,
  children,
  illustration,
  description,
}: Props) {
  return (
    <Dialog showing={state.isOpened} onClose={state.decline}>
      {title && (
        <DialogHeader>
          {illustration}
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
      )}
      {children && <DialogContent>{children}</DialogContent>}
      <DialogFooter bordered>
        <DialogButton onClick={state.decline}>{noText || 'No'}</DialogButton>
        <DialogButton type="danger" onClick={state.confirm}>
          {yesText || 'Yes'}
        </DialogButton>
      </DialogFooter>
    </Dialog>
  )
})

export function useConfirm() {
  const [viewModel] = React.useState(() => new ConfirmViewModel())
  return viewModel
}
